import { gql } from "@apollo/client";

export const SHARE_EVENT_PREVIEW = gql`
  query adminShareEventPreview($emails: [String!]!, $eventId: String) {
    adminShareEventPreview(emails: $emails, eventId: $eventId) {
      totalPasted
      matchedCount
      notFound
      eligibleCount
      alreadySharedCount
      notAllowedEmails
      inactiveCount
    }
  }
`;

/**
 * `source` says which screen is sharing. Four of them call these mutations, and
 * every share used to land in the log looking identical — so the results board
 * could see that events were shared but never by whom, which is the only thing
 * it's asked.
 */
export const SHARE_EVENT_TO_EMAILS = gql`
  mutation adminShareEventToEmails($eventId: String!, $emails: [String!]!, $source: OutreachSource) {
    adminShareEventToEmails(eventId: $eventId, emails: $emails, source: $source) {
      sharedCount
      notFound
    }
  }
`;

export const SHARE_EVENT_TO_USER_IDS = gql`
  mutation adminShareEventToUserIds(
    $eventId: String!
    $userIds: [String!]!
    $source: OutreachSource
  ) {
    adminShareEventToUserIds(eventId: $eventId, userIds: $userIds, source: $source) {
      sharedCount
      notFound
    }
  }
`;
